export default function TrustSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative bg-primary-900 rounded-3xl overflow-visible">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-5/12 relative -ml-4 lg:-ml-12 my-8 lg:my-0">
              <div className="relative h-80 lg:h-full min-h-[400px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20portrait%20of%20smiling%20person%20holding%20an%20opened%20fashion%20package%20box%20with%20tissue%20paper%2C%20warm%20natural%20daylight%20streaming%20through%20nearby%20window%2C%20minimalist%20cream%20and%20warm%20beige%20interior%20background%20with%20soft%20textured%20wall%2C%20authentic%20candid%20joyful%20moment%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20cozy%20comfortable%20home%20aesthetic%2C%20genuine%20happy%20expression&width=600&height=800&seq=trust-review-v3&orientation=portrait"
                  alt="Happy Kakobuy spreadsheet user"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:w-7/12 p-8 md:p-12 lg:p-14 flex flex-col justify-center">
              <div className="text-6xl md:text-8xl font-heading text-background-50/15 leading-none mb-4">
                &ldquo;
              </div>
              <blockquote className="text-base md:text-lg text-background-50 leading-relaxed mb-6 max-w-lg">
                &ldquo;The Kakobuy spreadsheet completely changed how I shop online. Instead
                of spending hours jumping between stores, I now browse organized product lists
                and discover items I genuinely love. The community recommendations are incredibly
                helpful — I have found so many hidden gems I would have never discovered on my own.&rdquo;
              </blockquote>
              <div className="mb-8">
                <p className="text-sm font-semibold text-background-50">Sarah Mitchell</p>
                <p className="text-xs text-background-50/50">Verified Kakobuy Sheet User</p>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-accent-100 text-accent-800 text-sm font-semibold px-6 py-3 rounded-full hover:bg-accent-200 transition-colors w-fit whitespace-nowrap"
              >
                Try Kakobuy Sheet <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="absolute -top-6 -left-6 hidden lg:block">
            <div className="w-16 h-16 rounded-full border-2 border-accent-300/30"></div>
          </div>
        </div>
      </div>
    </section>
  );
}